import { useContext } from "react";
import { useQuery, UseQueryResult } from "react-query";

import { isCorpNetworkConnected } from "@/apis/NetworkHelper";
import { AppContext } from "@/stores/appStore";

const REFETCH_INTERVAL_MS = 5_000; // 5 seconds

/**
 * Check if users are on a CORP network.
 */
export const useCheckVPNConnectivity = (): UseQueryResult => {
  const { state } = useContext(AppContext);

  // Stop rechecking once the network is connected by returning undefined interval.
  // This method is called once per refetch interval. When this hook is initialized, at least one call will be made to
  // the api.
  function getRefetchInterval() {
    return state.isNetworkConnected ? undefined : REFETCH_INTERVAL_MS;
  }

  return useQuery("checkVpnConnectivity", () => isCorpNetworkConnected(state), {
    refetchInterval: getRefetchInterval(),
  });
};
